import { IconProps } from './index';

const HeartLine: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M10.001 3.774a5 5 0 017.065 7.053L10 17.904l-7.066-7.076a5 5 0 017.067-7.053zm5.689 1.368a3.332 3.332 0 00-4.575-.128l-1.113.998-1.113-.997a3.333 3.333 0 00-4.738 4.67l5.85 5.86 5.85-5.858a3.334 3.334 0 00-.162-4.545z"
                fill="currentColor"
            />
        </svg>
    );
};

export default HeartLine;
